import { styled } from '@mui/joy';
import { CSSProperties } from 'react';
import { NavLink } from 'react-router-dom';

const propsToSkip: PropertyKey[] = ['hasUrl', 'isLoaded', 'style'];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

interface IWrapperProps {
  hasUrl: boolean;
  style?: CSSProperties;
}
interface IImgProps {
  isLoaded: boolean;
  style?: CSSProperties;
}

export const Wrapper = styled(NavLink, { shouldForwardProp })<IWrapperProps>(
  ({ theme, hasUrl, style }) => ({
    color: theme.palette.neutral[500],
    flexWrap: 'nowrap',
    cursor: 'default',
    ...(hasUrl && { cursor: 'pointer' }),
    ...style,
  })
);

export const Img = styled('img', { shouldForwardProp })<IImgProps>(({ isLoaded, style }) => ({
  height: 31,
  maxWidth: 100,
  display: isLoaded ? 'inherit' : 'none',
  ...style,
}));
